var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},_vm._l((_vm.locales),function(lang){return _c('a',{key:`language-${lang.value}`,staticClass:"locale-changer__link",class:{
      'locale-changer__link--monochrome': _vm.monochrome,
      'locale-changer__link--selected': lang.value === _vm.currentLocale
    },on:{"click":function($event){$event.preventDefault();return _vm.changeLanguage(lang.value)}}},[_vm._v(" "+_vm._s(lang.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }